import React from "react";
import type { ProductItemTilesToken } from "./productItemTiles.tokens";

export const baseStyles: Record<string, React.CSSProperties> = {
    section: {
        position: "relative",
        width: "100%",
        display: "grid",
        gap: 16,
        overflow: "hidden",
        boxSizing: "border-box",
    },
    header: {
        position: "relative",
        zIndex: 1,
        display: "grid",
        gap: 8,
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
    },
    eyebrow: {
        margin: 0,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "rgba(17,17,17,0.6)",
    },
    title: {
        margin: 0,
        fontSize: 32,
        lineHeight: 1.05,
        fontWeight: 700,
        color: "#111111",
    },
    description: {
        margin: 0,
        fontSize: 15,
        lineHeight: 1.6,
        color: "rgba(17,17,17,0.72)",
        maxWidth: 780,
    },
    scrollArea: {
        position: "relative",
        minWidth: 0,
    },
    scrollWrap: {
        width: "100%",
        overflowX: "auto",
        paddingBottom: 12,
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "thin",
    },
    track: {
        display: "flex",
        gap: 16,
        alignItems: "stretch",
    },
    itemWrap: {
        minWidth: 220,
        width: 220,
        flex: "0 0 auto",
        display: "flex",
    },
    edgeFade: {
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 12,
        zIndex: 2,
        width: 92,
        background: "linear-gradient(to left, rgba(255,255,255,0.96), rgba(255,255,255,0))",
    },
};

export const neutralStyles: Pick<ProductItemTilesToken, "scrollHint" | "scrollHintText" | "scrollHintIcon" | "ctaWrap" | "ctaButton"> = {
    scrollHint: {
        position: "absolute",
        right: 8,
        top: "50%",
        zIndex: 3,
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        transform: "translateY(-50%)",
        borderRadius: 999,
        padding: "8px 11px",
        background: "rgba(255,255,255,0.92)",
        color: "#111111",
        border: "1px solid rgba(17,17,17,0.08)",
        boxShadow: "0 10px 22px rgba(0,0,0,0.08)",
        pointerEvents: "none",
        animation: "productItemTilesSliderHint 1.9s ease-in-out infinite",
    },
    scrollHintText: {
        fontSize: 12,
        fontWeight: 750,
        lineHeight: 1,
        whiteSpace: "nowrap",
    },
    scrollHintIcon: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        height: 24,
        borderRadius: 999,
        background: "rgba(17,17,17,0.06)",
    },
    ctaWrap: {
        display: "flex",
        justifyContent: "flex-start",
        paddingTop: 2,
    },
    ctaButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 4,
        padding: "12px 18px",
        background: "#111111",
        color: "#ffffff",
        border: "1px solid #222222",
        fontSize: 14,
        fontWeight: 800,
        lineHeight: 1,
        textDecoration: "none",
        boxShadow: "0 10px 20px rgba(0,0,0,0.10)",
    },
};
